import { useState, useEffect, useCallback } from 'react'
import type { WikiPage } from '../types'
import { API_URL, getAuthHeaders } from '../api'



/**
 * Fetches and caches the flat list of wiki pages for the current workspace.
 * Returns { wikiPages, loading }.
 * wikiPages is an array of { id, title } (flattened from the tree).
 */
export function useWikiPages() {
  const [wikiPages, setWikiPages] = useState<{ id: string; title: string }[]>([])
  const [loading, setLoading] = useState(false)

  const fetchPages = useCallback(() => {
    const wsId = localStorage.getItem('atlas_ws_id') || ''
    if (!wsId) { setWikiPages([]); return }
    setLoading(true)
    fetch(`${API_URL}/api/wiki?workspace_id=${wsId}`, { headers: getAuthHeaders() })
      .then(r => r.json())
      .then(data => {
        // Flatten the tree
        const flat: { id: string; title: string }[] = []
        const walk = (list: WikiPage[]) => {
          for (const p of (list || [])) {
            flat.push({ id: p.id, title: p.title || 'Sem título' })
            if (p.children) walk(p.children)
          }
        }
        walk(data || [])
        setWikiPages(flat)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  useEffect(() => {
    fetchPages()
    // Refresh when workspace changes
    const handler = () => fetchPages()
    window.addEventListener('workspace-changed', handler)
    return () => window.removeEventListener('workspace-changed', handler)
  }, [fetchPages])

  return { wikiPages, loading, refresh: fetchPages }
}
